import { render, staticRenderFns } from "./MoreInformation.vue?vue&type=template&id=195a8279&scoped=true&"
import script from "./MoreInformation.vue?vue&type=script&lang=js&"
export * from "./MoreInformation.vue?vue&type=script&lang=js&"
import style0 from "./MoreInformation.vue?vue&type=style&index=0&id=195a8279&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a8279",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
